import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCategories, Category } from '../../services/api';

const AllCategoriesPage: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getCategories();
        setCategories(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Đã có lỗi xảy ra');
        console.error('Error fetching categories:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
    return (
      <div className='container mx-auto px-4 py-12'>
        <div className='flex items-center justify-center min-h-[300px]'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary'></div>
        </div>
      </div>
    );
  }

  if (error || categories.length === 0) {
    return (
      <div className='container mx-auto px-4 py-12'>
        <div className='bg-red-50 text-red-700 p-4 rounded-md'>
          <p>{error || 'Không tìm thấy danh mục nào'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className='container mx-auto px-4 py-8'>
      <h1 className='text-3xl font-bold text-gray-900 mb-8 text-center'>
        Danh mục sản phẩm
      </h1>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
        {categories.map((category) => (
          <Link
            key={category.id}
            to={`/categories/${category.slug}`}
            className='group'
          >
            <div className='rounded-lg overflow-hidden border border-gray-200 transition-shadow hover:shadow-md'>
              <div className='relative h-48'>
                <img
                  src={category.image}
                  alt={category.name}
                  className='w-full h-full object-cover group-hover:scale-105 transition-transform duration-300'
                />
                <div className='absolute inset-0 bg-black/30 flex items-center justify-center'>
                  <h2 className='text-xl md:text-2xl font-bold text-white'>
                    {category.name}
                  </h2>
                </div>
              </div>
              <div className='p-4 bg-white'>
                <div className='flex justify-between items-center'>
                  <p className='text-gray-700'>
                    {category.productCount} sản phẩm
                  </p>
                  <span className='text-primary font-medium'>Xem thêm</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AllCategoriesPage;
